import { ResourceEntry } from "./resource-entry/resource-entry";

export const addResourceEntryWidget = () => {
  window.kendo.ui.plugin(ResourceEntry);
};